<template>
  <div class="container p-0">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="card card-border-primary">
            <div class="card-header">
              <h5 class="card-title">A préparer</h5>
              <h6 class="card-subtitle text-muted">En attente de préparation</h6>
            </div>
            <div class="card-body p-3 scroll">
              <div class="card mb-3 bg-light" v-for="todo in todos" :key="todo.id">
                <card-kanban :state="todo" name="todos" v-model="selected" :roles="fullUser.roles" />
              </div>
            </div>
            <div class="card-footer bg-primary cursor p-4 text-white text-center" @click="todoToDoing">
              En préparation
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="card card-border-warning">
            <div class="card-header">
              <h5 class="card-title">En cours</h5>
              <h6 class="card-subtitle text-muted">En cours de préparation par un équipier</h6>
            </div>
            <div class="card-body scroll">
              <div class="card mb-3 bg-light" v-for="doing in doings" :key="doing.id">
                <card-kanban :state="doing" name="doings" v-model="selected" :roles="fullUser.roles" />
              </div>
            </div>
            <div class="card-footer bg-primary cursor p-4 text-white text-center" @click="doingToDone">
              Prêt
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="card card-border-danger">
            <div class="card-header">
              <h5 class="card-title">Prêt</h5>
              <h6 class="card-subtitle text-muted">Commandes prête à livré</h6>
            </div>
            <div class="card-body scroll">
              <div class="card mb-3 bg-light" v-for="done in dones" :key="done.id">
                <card-kanban :state="done" name="dones" v-model="selected" :roles="fullUser.roles" />
              </div>
            </div>
            <div class="card-footer bg-primary cursor p-4 text-white text-center" @click="doneToHide">
              Livré
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// https://www.bootdey.com/snippets/view/bs4-Kanban-Board
import {mapActions, mapState} from "vuex";
import cardKanban from "@/modules/home/components/CardKanban";

export default {
  name: 'TeamsDashboard',
  components:{
    cardKanban
  },
  props:['user'],
  data(){
    return {
      selected:null
    }
  },
  created() {
    const outlet = {outlets: this.fullUser.salespoint, admin: !!this.fullUser.roles.includes('ROLE_ADMIN')}
      this.loadTodo(outlet)
      this.loadDoing(outlet)
      this.loadDone(outlet)
  },
  computed:{
    ...mapState('auth',['fullUser']),
    ...mapState('orders',['todos','doings','dones']),
  },
  methods:{
    ...mapActions('orders',['stateOrderBasic','loadTodo','loadDoing','loadDone','switchOrderList']),
    todoToDoing(){
      this.switchOrderList({ origin: 'todo', target: 'doing', object: JSON.parse(this.selected) })
    },
    doingToDone(){
      this.switchOrderList({ origin: 'doing', target: 'done', object: JSON.parse(this.selected) })
    },
    doneToHide(){
      this.switchOrderList({ origin: 'done', target: 'close', object: JSON.parse(this.selected) })
    },
    arrayParse(array){
      return array.map(x => {
        return JSON.parse(x)
      })
    }
  }
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.scroll{
  height: 34rem;
  overflow-y: scroll;
}
.card {
  margin-bottom: 1.5rem;
  box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .025)
}

.card-border-primary {
  border-top: 4px solid #2979ff
}

.card-border-secondary {
  border-top: 4px solid #efefef
}

.card-border-success {
  border-top: 4px solid #00c853
}

.card-border-info {
  border-top: 4px solid #3d5afe
}

.card-border-warning {
  border-top: 4px solid #ff9100
}

.card-border-danger {
  border-top: 4px solid #ff1744
}

.card-border-light {
  border-top: 4px solid #f8f9fa
}

.card-border-dark {
  border-top: 4px solid #6c757d
}

.card-header {
  border-bottom-width: 1px
}

.card-actions a {
  color: #495057;
  text-decoration: none
}

.card-actions svg {
  width: 16px;
  height: 16px
}

.card-actions .dropdown {
  line-height: 1.4
}

.card-title {
  font-weight: 500;
  margin-top: .1rem
}

.card-subtitle {
  font-weight: 400
}

.card-table {
  margin-bottom: 0
}

.card-table tr td:first-child,
.card-table tr th:first-child {
  padding-left: 1.25rem
}

.card-table tr td:last-child,
.card-table tr th:last-child {
  padding-right: 1.25rem
}

.card-img-top {
  height: 100%
}
.card {
  margin-bottom: 1.5rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0,0,0,.025);
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #e5e9f2;
  border-radius: .2rem;
}

.card-header:first-child {
  border-radius: calc(.2rem - 1px) calc(.2rem - 1px) 0 0;
}

.card-header {
  border-bottom-width: 1px;
}
.card-header {
  padding: .75rem 1.25rem;
  margin-bottom: 0;
  color: inherit;
  background-color: #fff;
  border-bottom: 1px solid #e5e9f2;
}
</style>
